import React, { Component } from 'react'
import ImageButton from './base-components/ImageButton'

export default class NavigationGroup extends Component {
    getContent = (page)=>{
        //console.log(page)
        switch(page){
            case 1:
                return (
                [
                    <ImageButton src="./images/new1.png" alt="Crea un nuovo progetto" key="1" onClick={this.props.new}/>,
                    // <ImageButton src="./images/reload1.png" alt="Ripristina i parametri della pagina" key="2" onClick={()=>this.props.refresh()}/>,
                    <ImageButton src="./images/next1.png" alt="Vai alla pagina successiva" key="3" onClick={()=>this.props.changeStep(2)}/>
                ]);
            case 2:
                return (
                [
                    <ImageButton src="./images/prev1.png" alt="Indietro" key="0" onClick={()=>this.props.changeStep(1)}/>,
                    <ImageButton src="./images/new1.png" alt="Crea un nuovo progetto" key="1" onClick={this.props.new}/>,
                    // <ImageButton src="./images/reload1.png" alt="Ripristina i parametri della pagina" key="2" onClick={()=>this.props.refresh()}/>,
                    <ImageButton src="./images/next1.png" alt="Vai alla pagina successiva" key="3" onClick={()=>this.props.changeStep(3)}/>
                ]);
            case 3:
                return (
                [
                    <ImageButton src="./images/prev1.png" alt="Indietro" key="0" onClick={()=>this.props.changeStep(2)}/>,
                    <ImageButton src="./images/new1.png" alt="Crea un nuovo progetto" key="1" onClick={this.props.new}/>,
                    // <ImageButton src="./images/reload1.png" alt="Ripristina i parametri della pagina" key="2" onClick={()=>this.props.refresh()}/>,
                    <ImageButton src="./images/next1.png" alt="Vai alla pagina successiva" key="3" onClick={()=>{this.props.changeStep(4)}}/>
                ]);
            case 4:
                return (
                [
                    <ImageButton src="./images/prev1.png" alt="Indietro" key="0" onClick={()=>this.props.changeStep(3)}/>,
                    <ImageButton src="./images/new1.png" alt="Crea un nuovo progetto" key="1" onClick={this.props.new}/>,
                    // <ImageButton src="./images/reload1.png" alt="Ripristina i parametri della pagina" key="2" onClick={()=>this.props.refresh()}/>,
                    <ImageButton src="./images/next1.png" alt="Vai alla pagina successiva" key="3" onClick={()=>{this.props.changeStep(5)}}/>
                ]);
            case 5:
                return (
                [
                    <ImageButton src="./images/prev1.png" alt="Indietro" key="0" onClick={()=>this.props.changeStep(4)}/>,
                    <ImageButton src="./images/new1.png" alt="Crea un nuovo progetto" key="1" onClick={this.props.new}/>,
                    <ImageButton src="./images/pdf.png" alt="PDF" key="2" onClick={this.props.pdf}/>
                ]);
            default:
                return (<div></div>)
        }
    }

    render() {
        return (
            <div 
                style={{display: "flex", textAlign: "center", marginTop: "5px", paddingBottom: "5px"}}
                datarole="controlgroup"  
                datatype="horizontal" 
                className="navigation-control-group">
                    {this.getContent(this.props.page)}
            </div>
        )
    }
}
